/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Contacts.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContactType = 'NA' | 'Individual' | 'Business';

export const ContactType = {
    NA: 'NA' as ContactType,
    Individual: 'Individual' as ContactType,
    Business: 'Business' as ContactType
};
